// 商品標記定義 — 母/組文字 badge + 條件式 icon
// 陣列順序即渲染順序（文字 badge 在前、icon 在後）

/** 可傳入標記元件的商品來源（寬鬆型別，各 DTO 結構相容即可傳入） */
export interface ProductTagSource {
  StockType?: number;
  ProductType?: number;
  IsUseBatchNo?: boolean;
  IsInventory?: boolean;
}

/** 單一標記定義 */
export interface ProductTagDef {
  kind: 'badge' | 'icon';
  /** badge 修飾 class（模板固定加上 'stock-badge' 基底，這裡只放 stock-badge-parent / stock-badge-combine 之類的修飾） */
  class?: string;
  text?: string;
  /** icon 用（Material icon 名稱） */
  icon?: string;
  tooltip?: string;
  /** icon 顏色（CSS 色碼；未設則用 .product-tag-icon 的預設色） */
  color?: string;
  /** 顯示條件（回 true 才顯示） */
  show: (p: ProductTagSource) => boolean;
}

export const PRODUCT_TAG_DEFS: ProductTagDef[] = [
  { kind: 'badge', class: 'stock-badge-parent',  text: '母', show: p => p.StockType === 2 },
  { kind: 'badge', class: 'stock-badge-combine', text: '組', show: p => p.ProductType === 2 },
  { kind: 'icon',  icon: 'local_offer',  tooltip: '使用批號',   color: '#4caf50', show: p => p.IsUseBatchNo === true },
  { kind: 'icon',  icon: 'do_not_disturb_on',    tooltip: '不計算庫存', color: '#ff8a80', show: p => p.IsInventory === false },
];
